"use strict";


var TeamActions = require("app/screens/Team/actions/team-actions");
var TeamStore = require("app/screens/Team/stores/team-store");
var EmptyList = require("app/shared/components/List/empty-list");
var Button = require("app/shared/components/Button/button");
var Tooltip = require("app/shared/components/Tooltip/tooltip");
var AddTeamButton = require("app/screens/Team/shared/components/add-team-button");
var Icon = require("app/shared/components/Icon/icon");
var Separator = require("app/shared/components/Separator/separator");
var PromptAccountPrivacyChange = require("app/shared/components/Prompt/prompt-account-privacy-change");
var PromptConfirmButtonGroup = require("app/shared/components/Prompt/prompt-confirm-button-group");
var TeamList = require("app/screens/Team/components/TeamConfig/team-list");
var usersAPI = require("app/util/api/users");
var agendorAPI = require("app/util/api/agendor-api");
var SignalActions = require("app/shared/actions/signal-actions");
var TeamConfirmConsolidatePrompt = require("app/shared/components/TeamSelector/team-confirm-consolidate-prompt");
var PureRenderMixin = React.addons.PureRenderMixin;

var MIN_USER = 3;
var ERROR_MESSAGE_TIME = 5000;
var SUCCESS_MESSAGE_TIME = 3000;

var TeamConfig = React.createClass({
  mixins: [Reflux.ListenerMixin, ReactIntl.IntlMixin],

  propTypes: {
    accountActiveUsers: React.PropTypes.number.isRequired,
    isClosedPrivacy: React.PropTypes.bool,
    privacyChangeValue: React.PropTypes.object,
    pendingSynchronization: React.PropTypes.bool
  },

  getInitialState: function() {
    return {
      teams: null,
      isClosedPrivacy: this.props.isClosedPrivacy || false,
      showConsolidateTeamsPrompt: false,
      showSynchronizationWarning: this.props.pendingSynchronization,
      privacyChangeValue: this.props.privacyChangeValue
    }
  },

  componentDidMount: function() {
    this.listenTo(TeamStore, (state) => {
      this.setState(state);
      this.triggerStateChanged(state);
    });
    TeamActions.getTeams();
    this.loadUsers();
  },

  triggerStateChanged: function(state) {
    if (typeof this.props.onStateChanged == "function") {
      this.props.onStateChanged(state);
    }
  },

  loadUsers: function() {
    usersAPI.getAll(this.handleGetUserSuccess, this.handleRequestError);
  },

  handleGetUserSuccess: function(body, response) {
    if(body.length != 0) {
      this.setState({ users: body });
    }
  },

  handleRequestError: function(body, response) {
    if(body.length != 0) {
      SignalActions.show({
        message: "Não foi possível carregar as equipes cadastradas.",
        type: "success",
        hideTimeout: ERROR_MESSAGE_TIME
      });
    }
  },

  getOpenAccountWarning: function() {
    if (!this.state.isClosedPrivacy && this.props.accountActiveUsers >= MIN_USER) {
      return <OpenAccountWarning
        onOpenAccountSuccess={this.handleOpenAccountSuccess} />
    }
  },

  handleOpenAccountSuccess: function() {
    this.setState({ isClosedPrivacy: true });
  },

  handleOpenTeamConsolidatePrompt: function() {
    this.setState({ showConsolidateTeamsPrompt: true })
  },

  getHeader: function() {
    if (this.state.teams && this.state.teams.length > 0) {
      return <TeamConfigHeader 
        teams={this.state.teams}
        users={this.state.users} 
        handleOpenTeamConsolidatePrompt={this.handleOpenTeamConsolidatePrompt}
        showSynchronizationWarning={this.state.showSynchronizationWarning}
        privacyChangeValue={this.state.privacyChangeValue}
      />;
    }
  },

  getPageContent: function() {
    if (this.state.teams == null) {
      return <TeamConfigLoading />;
    } else if(this.props.accountActiveUsers >= MIN_USER || this.state.teams.length > 0) {
      return this.getTeamList();
    } else if (this.props.accountActiveUsers < MIN_USER) {
      return <FewUsers accountActiveUsers={this.props.accountActiveUsers} />;
    }
  },

  getTeamList: function() {
    var changingPrivacy = Boolean(this.state.privacyChangeValue);

    return <TeamList 
      teams={this.state.teams} 
      onClosePromptConfirmButtonGroup={this.handleOpenTeamConsolidatePrompt}
      users={this.state.users} 
      changingPrivacy={changingPrivacy}
    />;
  },

  handleSynchronizationWarning: function(state) {
    this.setState({ showSynchronizationWarning: state });
  },

  render: function() {
    return (
      <div className="w-100 h-100pct m-a">
        {this.getOpenAccountWarning()}
        {this.getHeader()}
        {this.getPageContent()}
        {this.state.showConsolidateTeamsPrompt 
          ? ( <TeamConfirmConsolidatePrompt
              isOpen={this.state.showConsolidateTeamsPrompt}
              onClose={() => this.setState({ showConsolidateTeamsPrompt: false })}
              handleSynchronizationWarning={this.handleSynchronizationWarning}
            /> ) 
          : null
        }
      </div>
    );
  }
});

var TeamConfigHeader = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    teams: React.PropTypes.array,
    users: React.PropTypes.array,
    showSynchronizationWarning: React.PropTypes.bool,
    privacyChangeValue: React.PropTypes.object
  },
  defaultProps: {
    teams: [],
    users: []
  },
  getTeamCount: function() {
    return this.props.teams ? this.props.teams.length : "";
  },

  getTeamCountText: function() {
    if (this.props.teams) {
      var foundMessage = this.getIntlMessage("team.found");
      var formattedFoundMessage = this.formatMessage(foundMessage, {
        teamsLength: this.props.teams.length
      });
      return formattedFoundMessage;
    }
  },

  getSynchronizationWarning: function() {
    if (this.props.showSynchronizationWarning && Boolean(!this.props.privacyChangeValue)) {
      return <SynchronizationWarning 
        handleOpenTeamConsolidatePrompt={this.props.handleOpenTeamConsolidatePrompt} 
      />
    }
  },

  getInProgressSynchronizationWarning: function() {
    if (this.props.privacyChangeValue) {
      return <InProgressSynchronizationWarning privacyChangeValue={this.props.privacyChangeValue}/>
    }
  },

  getDisabledAddButtonTooltipMessage: function() {
    return this.props.privacyChangeValue 
    ? "Para adicionar novas equipes será necessário aguardar a atualização de todos os dados finalizar. Tente novamente em alguns minutos." 
    : "";
  },

  render: function() {
    if (!this.props.teams) {
      return null;
    }
    var teamCount = this.getTeamCount();

    return (
      <div className="p-r mb-10">
       <div className="d-ib">
        <Tooltip 
          bottom 
          title={this.getDisabledAddButtonTooltipMessage()}
        >
          <AddTeamButton 
            users={this.props.users} 
            successPromptAction={this.props.handleOpenTeamConsolidatePrompt} 
            disabled={Boolean(this.props.privacyChangeValue)}
          />
        </Tooltip>
       </div>

       <div className="p-r f-r r-10 t-5">
         <span className="fw-600">{teamCount}</span>
         <span>{this.getTeamCountText()}</span>
       </div>

       {this.getSynchronizationWarning()}
       {this.getInProgressSynchronizationWarning()}
     </div>
    );
  }
});

var OpenAccountWarning = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  handleAccountPrivacyChange: function() {
    var closedAccountParams = {
      "privacy": {
        "mode": "closed"
      }
    };

    agendorAPI.put("/accounts/config", closedAccountParams, function(body, response){
      if (response && response.ok) {
        SignalActions.show({
          message: "Privacidade fechada com sucesso!",
          hideTimeout: SUCCESS_MESSAGE_TIME,
          type: "success"
        });
        this.props.onOpenAccountSuccess();
      } else {
        var errorMsg = "Não foi possível fechar a privacidade.";
        SignalActions.show({
          message: errorMsg,
          type: "warning",
          hideTimeout: ERROR_MESSAGE_TIME
        });
      }
    }.bind(this));
  },

  getJumbotronMessages: function() {
    var title = this.getIntlMessage("team.open_account_warning.title");
    var text = this.getIntlMessage("team.open_account_warning.text");
    return {
      title: title,
      text: text
    };
  },
  render: function() {
    var jumbotronMessages = this.getJumbotronMessages();

    return (
      <div className="bg-primarySalmon ta-c p-20 mb-20">
        <h3 className="ff-serif">{jumbotronMessages.title}</h3>
        <div className="maxw-85pct m-a">
          {jumbotronMessages.text}
        </div>

        <PromptConfirmButtonGroup>
          <PromptAccountPrivacyChange currentPrivacyValue="2" onConfirm={this.handleAccountPrivacyChange} />
          <Button type="warning" className="mt-20">
            <span className="flex-center-all">
              <Icon custom icon="lock" />
              <span>Fechar Privacidade</span>
            </span>
          </Button>
        </PromptConfirmButtonGroup>
      </div>
    );
  }
});

var SynchronizationWarning = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  render: function() {
    return (
      <div className='bg-secondaySalmon d-f flex-column ta-c p-24 mt-15 mb-15'>
        <Icon custom icon="warning" className='fs-26 p-4'/>
        <span className="fs-26 ff-serif">
          Conclua as alterações de equipes
        </span>
        <span className="d-ib mt-10 mb-10">
          As mudanças de equipes ainda não estão refletidas nas empresas, pessoas e negócios existentes.<br/>
          Clique no botão abaixo para atualizá-las.
        </span>
        <div>
          <Button
            type="primary"
            onClick={() => this.props.handleOpenTeamConsolidatePrompt()}
          >
            Concluir e iniciar atualização
          </Button>
        </div>
     </div>
    );
  }
});

var InProgressSynchronizationWarning = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    privacyChangeValue: React.PropTypes.object
  },
  getSyncMessage: function() {
    return this.props.privacyChangeValue.page === "config" 
      ? " a mudança de configuração de privacidade que foi feita." 
      : " as mudanças de equipes que foram feitas.";
  },
  render: function() {
    var message = this.getSyncMessage();
    return (
      <div className='bg-lightPrimaryBlue br-8 d-f ptb-10 pr-16 pl-16 mt-15 mb-15 align-center'>
        <Icon custom icon="loading-spinner" className='fs-20 p-4'/>
        <div className='ml-15'>
          <span className="fs-14 fw-bold">
            Atualização dos dados existentes em andamento
          </span>
          <span className="fs-12 d-ib mt-10">
            Estamos atualizando suas empresas, pessoas, negócios e tarefas para refletirem 
            {message}
          </span>
          <span className="fs-12 d-ib">
            Isso costuma levar alguns minutos, mas pode levar até mais de 1 hora dependendo da quantidade de registros da sua conta.
          </span>
        </div>
        <div>
        <a 
          href="https://ajuda.agendor.com.br/pt-BR/articles/8448796-por-que-preciso-atualizar-os-dados-apos-alterar-uma-equipe" 
          target="_blank"
          className='ml-20 fw-bold fs-12 nowrap'
        >
          Saiba mais
        </a>
        </div>
     </div>
    );
  }
});

var FewUsers = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  render: function() {
    var fewUsersMessage = this.getIntlMessage("team.few_active_users");
    var formattedFewUsersMessage = this.formatMessage(fewUsersMessage, {
      activeUserCount: this.props.accountActiveUsers,
      minUserCount: (MIN_USER - this.props.accountActiveUsers)
    });

    return (
      <EmptyList title="Convide usuários para criar equipes" subtitle={formattedFewUsersMessage}>
        <Button type="primary" className="mt-30" href={{url: "/sistema/usuarios/inserir.php", name: "_top"}}>
          <Icon icon="user" />
          <span className="ml-10">Convidar Usuário</span>
        </Button>
      </EmptyList>
    );
  }
});

const TeamConfigLoading = (props) => (
  <div className="js-teamConfigLoading p-r pl-20">
    <div className="p-r pb-10">
      <div style={{width: 160, height: 35}} className="bg-lightBlue o-50 br-4"></div>
      <div className="p-a f-r r-10 t-10">
        <div style={{width: 120, height: 10}} className="bg-grey br-30 o-50"></div>
      </div>
    </div>
    <div className="p-r">
      <div style={{width: 100, height: 15}} className="mt-12 bg-grey br-30 o-50"></div>
      <div style={{width: 200, height: 10}} className="mt-15 bg-grey br-30 o-50"></div>
      <Separator />
      <div style={{width: 100, height: 15}} className="mt-12 bg-grey br-30 o-50"></div>
      <div style={{width: 200, height: 10}} className="mt-15 bg-grey br-30 o-50"></div>
      <Separator />
    </div>
  </div>
);

module.exports = TeamConfig;



// WEBPACK FOOTER //
// ./app/screens/Team/components/TeamConfig/team-config.jsx